import type { ReactNode } from "react";
import classNames from "classnames";

import LoadingTwo from "../../atomic/LoadingTwo";

interface IProps {
  isLoading: boolean;
  children: ReactNode;
  className?: string;
  fallback?: ReactNode;
}

export default function UiConfigGate({
  isLoading,
  children,
  className,
  fallback
}: IProps) {
  if (!isLoading) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;

  return (
    <div
      role="status"
      aria-label="Loading"
      className={classNames(
        "flex w-full items-center justify-center py-20",
        className
      )}
    >
      <LoadingTwo style={{ width: 72, height: 72 }} />
    </div>
  );
}
